export enum PanelType {
  Scope = 'scope',
  NameInsured = 'nameInsured',
  Location = 'location',
}

export interface IStep {
  show: boolean;
  isOpen: boolean;
  isCompleted: boolean;
}

export interface IPanel {
  scope: IStep;
  nameInsured: IStep;
  location: IStep;
}

export const initialState: IPanel = {
  [PanelType.Scope]: {
    show: true,
    isOpen: true,
    isCompleted: false,
  },
  [PanelType.NameInsured]: {
    show: false,
    isOpen: false,
    isCompleted: false,
  },
  [PanelType.Location]: {
    show: false,
    isOpen: false,
    isCompleted: false,
  },
};

export const initialNameInsuredState: IPanel = {
  [PanelType.Scope]: {
    show: true,
    isOpen: false,
    isCompleted: true,
  },
  [PanelType.NameInsured]: {
    show: true,
    isOpen: true,
    isCompleted: false,
  },
  [PanelType.Location]: {
    show: false,
    isOpen: false,
    isCompleted: false,
  },
};

export const ERROR = {
  CREATE_CUSTOMER: 'Saving customer has failed. If errors continue, please contact support',
  CREATE_INSURED_LOCATIONS: 'Saving locations has failed. If errors continue, please contact support',
  CREATE_QUOTE: 'Creating quote has failed. If errors continue, please contact support',
  CUSTOMER_MATCH_CONFLICT:
    'A matching customer was found while saving. Please revisit the Named Insured step to resolve it.',
};
